import { PropsWithChildren } from 'react';
import styles from './sidebar-layout.module.css';
import { ClassName, cn } from '../../utils';
import { Icon } from '../../components';

type SidebarLayoutProps = PropsWithChildren<{
  sidebar?: React.ReactNode;
  title?: string;
  titleComponent?: React.ElementType<{ className?: ClassName; title: string }>;
  className?: ClassName;
  sidebarTitle?: string;
  backLink?: string;
}>;
export function SidebarLayout({
  children,
  title,
  titleComponent: TitleComponent,
  sidebar,
  sidebarTitle,
  backLink,
  className,
}: SidebarLayoutProps) {
  if (!sidebar) return children;
  return (
    <div className={cn(styles['container'], className)}>
      {(!!backLink || title) && (
        <div className={styles['content-top']}>
          {backLink && (
            <a
              className={styles['back-button']}
              aria-label="Back"
              href={backLink}
            >
              <Icon name="chevron-left" />
            </a>
          )}
          {title && !!TitleComponent ? (
            <TitleComponent className={styles.title} title={title} />
          ) : (
            <h1 className={styles.title}>{title}</h1>
          )}
        </div>
      )}

      {children && (
        <main id="content" className={styles['content']}>
          {children}
        </main>
      )}

      <aside id="sidebar" className={styles['sidebar']}>
        {sidebarTitle && (
          <h2 className={styles['sidebar-title']}>{sidebarTitle}</h2>
        )}
        <div className={styles['sidebar-content']}>{sidebar}</div>
      </aside>
    </div>
  );
}
